import React from "react";
import EsgContainer from "../esg/EsgContainer";
 
const CuestionarioGenero = () => {
  return <EsgContainer page="bivaasg-cuestionario-genero" isCuestionario={true} isGenero={true}/>;
};

export default CuestionarioGenero;
 